<template>

  <ion-page id="landing2-page">
    <ion-content :key="menuTrigger">

    <div v-if="fromMainPage">
      <TopLine :style="styleTopline" :title="titleString" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>
    </div>
    <div v-if="!fromMainPage">
      <!-- <ion-header :style="styleTopline"> -->
      <div :style="styleTopline">
        <ion-toolbar >
          <ion-title @click="onClick('home')">Verbal Chess</ion-title>
          <ion-buttons slot="end">
            <div v-show="isWide">
              <ion-button @click="onClick('home')">
                {{ homeString }}
              </ion-button>
            </div>
            <ion-button @click="onClick('features')">
              {{ featureString }}
            </ion-button>
            <ion-button @click="onClick('videos')">
              {{ videoString }}
            </ion-button>
            <div v-show="isWide">
              <ion-button @click="onClick('chessvis')">
                Chessvis
              </ion-button>
            </div>
            <div v-if="!fromMainPage">
              <ion-item class="ion-text-wrapper">
                <ion-icon :icon="globeOutline"></ion-icon>
                <ion-select
                  :value="languageInUse"
                  justify="start"
                  @ionChange="handleChange($event,'language')"
                  @ionCancel="handleCancel()"
                  @ionDismiss="handleDismiss()">
                  <div v-for="item in languages">
                    <ion-select-option :value="item.radio">{{ item.radio }}</ion-select-option>
                  </div>
                </ion-select>
              </ion-item>
            </div>
          </ion-buttons>
        </ion-toolbar>
      </div>
      <!-- </ion-header> -->
    </div>

   <div :style="styleMiddleToUse" id="scroll_point">

    <div class="hero" id="home">

      <!-- WIDE -->

      <div v-show="isWide">
        <div class="big_font section_padding_top">
          {{ heroHeading }}
        </div>
        <div class="small_font small_font_extra_margin">
          {{ heroSubheading }}
        </div>
        <ion-grid class="wide_margin">
          <ion-row v-if="true || !fromMainPage">
            <ion-col>
              <ion-button shape="round" size="small" class="tall-button" @click="onClick('web')">
                <ion-icon :icon="globeOutline"></ion-icon>
                {{ playWebNow }}
              </ion-button>
              <ion-label class="install-hint">
                {{ installableWeb }}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button shape="round" size="small" class="tall-button" @click="onClick('android')">
                <ion-icon :icon="downloadOutline"></ion-icon>
                {{ downloadAndroid }}
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-button shape="round" size="small" class="tall-button" @click="onClick('ios')">
                <ion-icon :icon="downloadOutline"></ion-icon>
                {{ downloadIOS }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
        <img alt="whimsy on the chessboard" src="/img/landing_page/all_pieces.jpg" />
      </div>

      <!-- NARROW -->

      <div v-show="!isWide">
        <div class="big_font_small_screen section_padding_top">
          {{ heroHeading }}
        </div>
        <div class="smaller_font small_font_extra_margin">
          {{ heroSubheading }}
        </div>
        
        <div v-if="!fromMainPage">
          <ion-button shape="round" size="small" class="smaller_font tall-button"  @click="onClick('web')">
            <ion-icon :icon="globeOutline"></ion-icon>
            {{ playWebNow }}
          </ion-button>
          <ion-label class="install-hint">
            {{ installableWeb }}
          </ion-label>
        </div>

        <ion-button shape="round" size="small" class="smaller_font tall-button"  @click="onClick('android')">
          <ion-icon :icon="downloadOutline"></ion-icon>
          {{ downloadAndroid }}
        </ion-button>
        <ion-button shape="round" size="small" class="smaller_font tall-button"  @click="onClick('ios')">
          <ion-icon :icon="downloadOutline"></ion-icon>
          {{ downloadIOS }}
        </ion-button>
        <img alt="whimsy on the chessboard" src="/img/landing_page/all_pieces.jpg" />
      </div>
    </div>

    <!-- Play While Doing Other Things -->

    <div id="features" class="dark_tan_background">

      <!-- WIDE -->

      <div v-show="isWide">
        <ion-grid>
          <ion-row>
            <ion-col>
              <img alt="chess king on the beach" src="/img/landing_page/cropped_chess_king_kneading_dough_5_second_movie.gif" />
            </ion-col>
            <ion-col>
              <div class="big_font">
                {{ chessForAllHeading }}
              </div>
              <div class="small_font">
                {{ chessForAllSubheading }}
              </div>
                <div class="small_font">
                <ul>
                  <li>{{ chessForAllDetail1 }}</li>
                  <li>{{ chessForAllDetail2 }}</li>
                  <li>{{ chessForAllDetail3 }}</li>
                  <li>{{ chessForAllDetail4 }}</li>
                </ul>
              </div>
              <div class="big_font margin_between_video_rows">
                {{ playWhileHeading }}
              </div>
              <div class="small_font">
                {{ playWhileItem1 }}
              </div>
             
              <div class="small_font">
                <ul>
                  <li>{{ playWhileLi1 }}</li>
                  <li>{{ playWhileLi2 }}</li>
                  <li>{{ playWhileLi3 }}</li>
                  <li>{{ playWhileLi4 }}</li>
                </ul>
              </div>
            </ion-col>
          </ion-row>

        </ion-grid>
      </div>

      <!-- NARROW -->

      <div v-show="!isWide" class="not_wide_margins">
         <div class="big_font_small_screen text_centered">
          {{ chessForAllHeading }}
        </div>
        <div class="smaller_font">
          {{ chessForAllSubheading }}
        </div>
          <div class="smaller_font">
          <ul>
            <li>{{ chessForAllDetail1 }}</li>
            <li>{{ chessForAllDetail2 }}</li>
            <li>{{ chessForAllDetail3 }}</li>
            <li>{{ chessForAllDetail4 }}</li>
          </ul>
        </div>
        <div class="big_font_small_screen text_centered">
          {{ playWhileHeading }}
        </div>
        <div class="smaller_font">
          {{ playWhileItem1 }}
        </div>
        <div class="smaller_font">
          <ul class="list_smaller_screen">
            <li>{{ playWhileLi1 }}</li>
            <li>{{ playWhileLi2 }}</li>
            <li>{{ playWhileLi3 }}</li>
            <li>{{ playWhileLi4 }}</li>
          </ul>
        </div>

        <div class="text_centered">
              <img width="250" height="350" alt="chess king on the beach" src="/img/landing_page/cropped_chess_king_kneading_dough_5_second_movie.gif" />
        </div>
      </div>
    </div>

    <!-- Chess for Everyone, Kneading Bread -->

    <!-- <div class="dark_tan_background"> -->

      <!-- WIDE -->

      <!-- <div v-show="isWide">
        <ion-grid>
          <ion-row>
            <ion-col>
              <div class="big_font big_font_extra_margin_top">
                {{ chessForAllHeading }}
              </div>
              <div class="small_font">
                {{ chessForAllSubheading }}
              </div>
              <div class="small_font list_smaller_screen">
                <ul>
                  <li>{{ chessForAllDetail1 }}</li>
                  <li>{{ chessForAllDetail2 }}</li>
                  <li>{{ chessForAllDetail3 }}</li>
                  <li>{{ chessForAllDetail4 }}</li>
                </ul>
              </div>
            </ion-col>
            <ion-col>
              <img alt="chess king kneading bread" src="/img/landing_page/chess king kneeding dough.png" />
            </ion-col>
          </ion-row>

        </ion-grid>
      </div> -->

      <!-- NARROW -->

      <!-- <div v-show="!isWide" class="litte_left_right_margin">
        <div class="big_font_small_screen text_centered">
          {{ chessForAllHeading }}
        </div>
        <div class="smaller_font">
          {{ chessForAllSubheading }}
        </div>
        <div class="smaller_font">
          <ul>
            <li>{{ chessForAllDetail1 }}</li>
            <li>{{ chessForAllDetail2 }}</li>
            <li>{{ chessForAllDetail3 }}</li>
            <li>{{ chessForAllDetail4 }}</li>
          </ul>
        </div>
        <div class="text_centered border_rounded litte_extra_top_bottom">
          <img class="border_rounded" width="200" height="200" alt="chess king kneading bread" src="/img/landing_page/chess king kneeding dough.png" />
        </div>
      </div>
    </div> -->

    <!-- What you can do with Verbal Chess, Chess Board -->
    <div class="white_background">

      <!-- WIDE -->

      <div v-show="isWide">

        <div class="big_font text_centered section_padding_top">
          {{ whatYouCanDoHeading }}
        </div>
        <div class="small_font text_centered">
          {{ whatYouCanDoSubHeading }}
        </div>
        <ion-grid>
          <ion-row>    
            <ion-col size="5">
              <img alt="chess king on the beach" src="/img/landing_page/chess_board.png" />
            </ion-col>
            <ion-col size="7">
              <div>
                <ion-grid>
                  <ion-row class="dark_tan_background stacked_item_spacing">
                    <ion-col size="2">
                      <img alt="icon play computer" src="/img/landing_page/icon_play_against_computer.png" />
                    </ion-col>
                    <ion-col>
                      <div class="medium_font stacked_item_heading_spacing">
                        {{ whatYouCanDo1 }}
                      </div>
                      <div class="smaller_font">
                        {{ whatYouCanDo1detail }}
                      </div>
                    </ion-col>
                  </ion-row>
                  <ion-row class="dark_tan_background stacked_item_spacing">
                    <ion-col size="2">
                      <img alt="icon play lichess" src="/img/landing_page/icon_play_lichess.png" />
                    </ion-col>
                    <ion-col>
                      <div class="medium_font stacked_item_heading_spacing">
                        {{ whatYouCanDo2 }}
                      </div>
                      <div class="smaller_font">
                        {{ whatYouCanDo2detail }}
                      </div>
                    </ion-col>
                  </ion-row>
                  <ion-row class="dark_tan_background stacked_item_spacing">
                    <ion-col size="2">
                      <img alt="icon play lichess" src="/img/landing_page/icon_blindfold_no_hearts.png" />
                    </ion-col>
                    <ion-col>
                      <div class="medium_font stacked_item_heading_spacing">
                        {{ whatYouCanDo3 }}
                      </div>
                      <div class="smaller_font">
                        {{ whatYouCanDo3detail }}
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <!-- NARROW -->

      <div v-show="!isWide" class="padding_extra_bottom text_centered">
        <div class="big_font_small_screen text_centered section_padding_top">
          {{ whatYouCanDoHeading }}
        </div>
        <div class="smaller_font ">
          {{ whatYouCanDoSubHeading }}
        </div>
        <img width="200" height="200" alt="chess king on the beach" src="/img/landing_page/chess_board.png" />
        <div class="dark_tan_background stacked_item_spacing text_centered litte_extra_top_bottom not_wide_margins">
            <img width="50" height="50" alt="icon play computer" src="/img/landing_page/icon_play_against_computer.png" />
            <div class="medium_font stacked_item_heading_spacing">
              {{ whatYouCanDo1 }}
            </div>
            <div class="smaller_font">
              {{ whatYouCanDo1detail }}
            </div>
        </div>
        <div class="dark_tan_background stacked_item_spacing text_centered litte_extra_top_bottom not_wide_margins">
            <img width="50" height="50" alt="icon play lichess" src="/img/landing_page/icon_play_lichess.png" />
            <div class="medium_font stacked_item_heading_spacing">
              {{ whatYouCanDo2 }}
            </div>
            <div class="smaller_font">
              {{ whatYouCanDo2detail }}
            </div>
        </div>
        <div class="dark_tan_background stacked_item_spacing text_centered litte_extra_top_bottom not_wide_margins">
            <img width="50" height="50" alt="icon play lichess" src="/img/landing_page/icon_blindfold_no_hearts.png" />
            <div class="medium_font stacked_item_heading_spacing">
              {{ whatYouCanDo3 }}
            </div>
            <div class="smaller_font">
              {{ whatYouCanDo3detail }}
            </div>
        </div>
      </div>
    </div>

    <!-- see verbal chess in action -->
    <div id="videos" class="dark_tan_background">
      <div class="big_font text_centered section_padding_top">
        {{ inActionHeading }}
      </div>
      <div class="smaller_font text_centered wide_margin">
        {{ inActionSubheading }}
      </div>
      <ion-grid>
        <ion-row class="ion-justify-content-center">
           <ion-col>
            <div class="text_centered">
              <video class="video_frame" controls poster="/img/landing_page/chess_king_on_beach.gif">
                <source src="https://www.verbalchess.fun/commands.mp4"></source>
              </video>
            </div>
            <div class="medium_font text_centered">
              {{ inActionNavigateHeading }}
            </div>
            <div class="smaller_font text_centered wide_margin">
              {{ inActionNavigateSubheading }}
            </div>

          </ion-col>
          <ion-col>
            <div class="text_centered xc">
              <video class="video_frame" controls poster="/img/landing_page/treadmill.png">
                <source src="https://www.verbalchess.fun/treadmill.mp4"></source>
              </video>
            </div>
            <div class="medium_font text_centered">
              {{ inActionPlayHeading }}
            </div>
            <div class="smaller_font text_centered wide_margin">
              {{ inActionPlaySubheading }}
            </div>
          </ion-col>
        </ion-row>
          <ion-row class="ion-justify-content-center margin_between_video_rows">
           <ion-col>
            <div class="text_centered">
              <video class="video_frame" controls poster="/img/landing_page/chess_king_at_the_club_with_drink_and_cigar.png">
                <source src="https://www.verbalchess.fun/lichess.mp4"></source>
              </video>
            </div>
            <div class="medium_font text_centered">
              {{ inActionPlayWorldHeading }}
            </div>
            <div class="smaller_font text_centered wide_margin">
              {{ inActionPlayWorldSubheading }}
            </div>

          </ion-col>
          <ion-col>
            <div class="text_centered xc">
              <video class="video_frame" controls poster="/img/landing_page/chess king sitting in throne with blindfold_on_holding_tablet.png">
                <source src="https://www.verbalchess.fun/blindfold.mp4"></source>
              </video>
            </div>
            <div class="medium_font text_centered">
              {{ inActionBlindfoldHeading }}
            </div>
            <div class="smaller_font text_centered wide_margin">
              {{ inActionBlindfoldSubheading }}
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

     <!-- why verbal chess is unique -->

    <div class="very_light_background">

      <!-- WIDE -->

      <div v-show="isWide">
        <div class="big_font text_centered section_padding_top">
          {{ whyUniqueHeading }}
        </div>
        <div class="small_font text_centered wide_margin">
          {{ whyUniqueSubheading }}
        </div>
        <ion-grid>
          <ion-row>
            <ion-col>
              <img alt="hands-free gameplay" src="/img/landing_page/hands_free_gameplay.png" />
            </ion-col>
            <ion-col>
              <img alt="hands-free gameplay" src="/img/landing_page/accessibility.png" />
            </ion-col>
              <ion-col>
              <img alt="hands-free gameplay" src="/img/landing_page/full_menu_control.png" />
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <!-- NARROW -->

      <div v-show="!isWide" class="text_centered">
        <div class="big_font_small_screen text_centered section_padding_top">
          {{ whyUniqueHeading }}
        </div>
        <div class="smaller_font text_centered wide_margin">
          {{ whyUniqueSubheading }}
        </div>
          <img width="250" alt="hands-free gameplay" src="/img/landing_page/hands_free_gameplay.png" />
          <img width="250" alt="hands-free gameplay" src="/img/landing_page/accessibility.png" />
          <img width="250" alt="hands-free gameplay" src="/img/landing_page/full_menu_control.png" />
      </div>

    </div>
   
    <!-- experience verbal chess anywhere -- REMOVED -->

    <!-- <div class="dark_tan_background">

      *** WIDE ***

      <div v-show="isWide">
        <div class="big_font text_centered section_padding_top">
          {{ experienceHeading }}
        </div>
        <div class="small_font text_centered wide_margin">
          {{ experienceSubheading }}
        </div>
        <ion-grid>
          <ion-row>
            <ion-col>
              <img alt="hands-free gameplay" src="/img/landing_page/web_version.png" />
            </ion-col>
            <ion-col>
              <img alt="hands-free gameplay" src="/img/landing_page/mobile_version.png" />
            </ion-col>
          </ion-row>

        </ion-grid>
      </div>

      *** NARROW ***

      <div v-show="!isWide" class="text_centered">
        <div class="big_font_small_screen text_centered section_padding_top">
          {{ experienceHeading }}
        </div>
        <div class="smaller_font text_centered wide_margin">
          {{ experienceSubheading }}
        </div>
        <img width="250"  alt="hands-free gameplay" src="/img/landing_page/web_version.png" />
        <img width="250" alt="hands-free gameplay" src="/img/landing_page/mobile_version.png" />
      </div>

    </div> -->

    <!-- last bit -->

    <div class="black_background text_centered">
      <div class="medium_font ready_to_play_extra_margin">
        {{  readyToPlay }}
      </div>

      <!-- WIDE -->

      <div v-show="isWide">
        <ion-grid class="wide_margin">
          <ion-row  v-if="!fromMainPage">
            <ion-col>
              <ion-button shape="round" size="small" class="tall-button" @click="onClick('web')">
                <ion-icon :icon="globeOutline"></ion-icon>
                {{ playWebNow }}
              </ion-button>
              <ion-label class="install-hint install-hint-white">
                {{ installableWeb }}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button shape="round" size="small" class="tall-button" @click="onClick('android')">
                <ion-icon :icon="downloadOutline"></ion-icon>
                {{ downloadAndroid }}
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-button shape="round" size="small" class="tall-button" @click="onClick('ios')">
                <ion-icon :icon="downloadOutline"></ion-icon>
                {{ downloadIOS }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <!-- NARROW -->

      <div v-show="!isWide">
        <div v-if="!fromMainPage">
          <ion-button shape="round" size="small" class="tall-button" @click="onClick('web')">
            <ion-icon :icon="globeOutline"></ion-icon>
            {{ playWebNow }}
          </ion-button>
          <ion-label class="install-hint install-hint-white">
            {{ installableWeb }}
          </ion-label>
        </div>
        <ion-button shape="round" size="small" class="tall-button"  @click="onClick('android')">
          <ion-icon :icon="downloadOutline"></ion-icon>
          {{ downloadAndroid }}
        </ion-button>
        <ion-button shape="round" size="small" class="tall-button" @click="onClick('ios')">
          <ion-icon :icon="downloadOutline"></ion-icon>
          {{ downloadIOS }}
        </ion-button>
      </div>

      <div class="smaller_font margin_between_video_rows">
        {{ contactString }}: support@chessvis.com
        <p>
        Copyright 2021-2026, Conceptual Software, Inc. All Rights Reserved.
        </p>
      </div>
    </div>
  </div>
  <div v-if="fromMainPage">
    <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </div>
</ion-content>
</ion-page>
</template>

<script setup>

// https://www.verbalchess.fun/commands.mp4
// https://www.verbalchess.fun/treadmill.mp4
// https://www.verbalchess.fun/blindfold.mp4
// https://www.verbalchess.fun/lichess.mp4

 

//https://www.docs4.dev/posts/easy-bootstrap-5-integration-with-vue-3-step-by-step-guide

  import { IonSelect,IonSelectOption,IonImg,IonLabel,IonCol, IonRow, IonGrid, IonButton, IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
  import { IonIcon,IonHeader,IonTitle,IonMenuButton,IonButtons,IonToolbar,IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle } from '@ionic/vue';

  import { downloadOutline,caretForwardOutline, caretUpOutline , caretDownOutline } from 'ionicons/icons';
  import { menuOutline,globeOutline } from 'ionicons/icons';

  import { computed } from "@vue/reactivity"
  import { ref , watch , onMounted } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import {  buildStyleToolbar,buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    buildStyleMiddleNoToolbar,
    calculateChessBoardRect, isScreenPortraitOrientation , buildStyleFullScreen } from '@/composables/screenSize'
  import { translateEnglishWords , translatePhrase , setTranslationLanguage } from '@/composables/translation';
  import { parseWordsSaid , buildWordListFromChoiceList, parseNumberWords } from '@/composables/wordlistSupport.js'

  import { useGetData, generateErrorAlertText } from '@/composables/getData.js'
  import ToolBar from '@/components/ToolBar.vue'
  import TopLine from '@/components/TopLine.vue'

// import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

  const connectionStore = useConnectionStore()

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      },
      fromMainPage : {
        type : Boolean,
        default : false
      }
    })

  
  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const fromMainPage = computed({get() {return props.fromMainPage}})

  const menuTrigger = ref(0)

  const wordlistTrigger = ref(0)
  const wordlistVoices = "command scroll up down done ignore mute listen";
  const wordlist = ref(wordlistVoices)
  emit("word-list",wordlistVoices)

  const smallScreenBreakpoint = 576
  const isWide = ref( window.innerWidth >= smallScreenBreakpoint)

  const languageInUse = ref(connectionStore.getLanguageInUse)

  const homeString = ref("")
  const featureString = ref("")
  const videoString = ref("")

  const heroHeading = ref("")
  const heroSubheading = ref("")
  const downloadAndroid = ref("")
  const downloadIOS = ref("")
  const playWebNow = ref("")
  const installableWeb = ref("")

  const startPlayingButton = ref("")
  const playWhileHeading = ref("")
  const playWhileItem1 = ref("")
  
  const playWhileLi1 = ref("")
  const playWhileLi2 = ref("")
  const playWhileLi3 = ref("")
  const playWhileLi4 = ref("")
  
  const inActionHeading = ref("")
  const inActionSubheading = ref("")
  
  const inActionNavigateHeading = ref("")
  const inActionNavigateSubheading = ref("")
  const inActionPlayHeading = ref("")
  const inActionPlaySubheading = ref("")
  const inActionPlayWorldHeading = ref("")
  const inActionPlayWorldSubheading = ref("")
  const inActionBlindfoldHeading = ref("")
  const inActionBlindfoldSubheading = ref("")
  
  const chessForAllHeading = ref("")
  const chessForAllSubheading = ref("")
  const chessForAllDetail1 = ref("")
  const chessForAllDetail2 = ref("")
  const chessForAllDetail3 = ref("")
  const chessForAllDetail4 = ref("")

  const whatYouCanDoHeading = ref("")
  const whatYouCanDoSubHeading = ref("")
  const whatYouCanDo1 = ref("")
  const whatYouCanDo1detail = ref("")
  const whatYouCanDo2 = ref("")
  const whatYouCanDo2detail = ref("")
  const whatYouCanDo3 = ref("")
  const whatYouCanDo3detail = ref("")
 
  const whyUniqueHeading = ref("")
  const whyUniqueSubheading = ref("")
  
  const experienceHeading = ref("")
  const experienceSubheading = ref("")

  const readyToPlay = ref("")
  const contactString = ref("")

  //const fromMainPage = ref(true)

  const languages = [
      { name :  translateEnglishWords("English"), radio : "en"},
      { name :  translateEnglishWords("Spanish"), radio : "es"},
      { name :  translateEnglishWords("French"), radio : "fr"},
      { name :  translateEnglishWords("German"), radio : "de"},
      { name :  translateEnglishWords("Italian"), radio : "it"},
      { name :  translateEnglishWords("Portuguese"), radio : "pt"},
    ]

  const titleString = ref(translateEnglishWords("Verbal Chess Landing Page"))
  const TOOLBAR_UP = 0
  const TOOLBAR_DOWN = 1

  const toolbarElements = ref([
    { index : TOOLBAR_UP, label : translateEnglishWords("Scroll Up") ,disabled : false},
    { index : TOOLBAR_DOWN, label : translateEnglishWords("Scroll Down") ,disabled : false},
    ])

  const toolbarTrigger = ref(0)

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)

  const windowSizeStore = useWindowSizeStore()

  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddleNoToolbar = ref(buildStyleMiddleNoToolbar(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))
  const styleMiddleToUse = ref((fromMainPage.value) ? styleMiddle : styleMiddleNoToolbar)
  const styleFullScreen = ref(buildStyleFullScreen())
  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))

  translateText()

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log("size changed",window.innerWidth)

    styleFullScreen.value = buildStyleFullScreen()
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddleNoToolbar.value = buildStyleMiddleNoToolbar(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleMiddleToUse.value = (fromMainPage.value) ? styleMiddle.value : styleMiddleNoToolbar.value

    isWide.value = (window.innerWidth >= smallScreenBreakpoint)
    menuTrigger.value++
    console.log("is wide",isWide.value)
  })

  watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   function translateText() {
      homeString.value =translatePhrase("Home")
      featureString.value =translatePhrase("Features")
      videoString.value =translatePhrase("Videos")

      heroHeading.value =translatePhrase("The World's Only Fully Voice-Controlled Chess App")
      heroSubheading.value =translatePhrase("Experience chess like never before - with your voice!")
      downloadAndroid.value =translatePhrase("Download For Android")
      downloadIOS.value =translatePhrase("Download For IOS")
      playWebNow.value =translatePhrase("Play Now on the Web (Where New Features Live)")
      installableWeb.value = translatePhrase("Installs to your home screen — works just like an app")

      startPlayingButton.value =translatePhrase("Start Playing Now")
      playWhileHeading.value =translatePhrase("Play While You Do Other Things!")
      playWhileItem1.value =translatePhrase("Why stop life to play chess? With Verbal Chess, your moves flow naturally through voice commands. Cook dinner, go for a walk, or relax on the beach -- all while staying fully engaged in your match. Chess becomes part of your lifestyle, not a disruption.")
      
      playWhileLi1.value =translatePhrase("Cook dinner and call your moves hand-free")
      playWhileLi2.value =translatePhrase("Stay active while keeping your mind sharp")
      playWhileLi3.value =translatePhrase("Relax anywhere -- no screen tapping required")
      playWhileLi4.value =translatePhrase("Sneak in a match during a break at work")
      
      inActionHeading.value =translatePhrase("See Verbal Chess in Action")
      inActionSubheading.value =translatePhrase("Want to see how Verbal Chess works in real-time? Watch these quick 30-second demos showcasing the power of voice control in action. Experience how playing chess can be easier, more fun, and more accessible.")
      
      inActionNavigateHeading.value =translatePhrase("Navigate the Menus")
      inActionNavigateSubheading.value =translatePhrase("Every menu, every setting, every option — all controlled by voice, hands completely free.")
      inActionPlayHeading.value =translatePhrase("Play a Few Moves")
      inActionPlaySubheading.value =translatePhrase("Show how the player can issue voice commands to make moves on the chessboard.")
      inActionPlayWorldHeading.value =translatePhrase("Play Around the World")
      inActionPlayWorldSubheading.value =translatePhrase("In addition to playing the computer, play on Lichess.org against anyone around the world.")
      inActionBlindfoldHeading.value =translatePhrase("Everyone Can Play Blindfold Chess")
      inActionBlindfoldSubheading.value =translatePhrase("Call out your moves while the board stays in your mind. Blindfold chess, made achievable for everyone.")
      
      chessForAllHeading.value =translatePhrase("Chess for Everyone, Hands-Free!")
      chessForAllSubheading.value =translatePhrase("Verbal Chess was built with inclusivity in mind. Whether you live with limited mobility, visual impairments, or simply prefer a hands-free experience, this app makes the timeless game of chess accessible to all. Every move, every option, and every feature is voice-enabled -- so no one is left behind.")
      chessForAllDetail1.value =translatePhrase("Designed with accessibility first")
      chessForAllDetail2.value =translatePhrase("Voice commands work across every game function")
      chessForAllDetail3.value =translatePhrase("Bring chess to players who previously couldn't enjoy it")
      chessForAllDetail4.value =translatePhrase("Play chess anywhere your hands are busy")

      whatYouCanDoHeading.value =translatePhrase("What you can do with Verbal Chess")
      whatYouCanDoSubHeading.value =translatePhrase("Verbal Chess isn't just voice-controlled -- it's a complete chess experience. Play your way.")
      whatYouCanDo1.value =translatePhrase("Play Against the Computer")
      whatYouCanDo1detail.value =translatePhrase("From beginner-friendly levels to world-champion strength engines -- train, practice, and grow at your pace")
      whatYouCanDo2.value =translatePhrase("Play Online with the World")
      whatYouCanDo2detail.value =translatePhrase("Integrated with Lichess.org for 24/7 games. Find opponents worldwide, play fast or slow games, join tournaments or challenge friends.")
      whatYouCanDo3.value =translatePhrase("Play Blindfold Chess")
      whatYouCanDo3detail.value =translatePhrase("The original idea behind Verbal Chess. Close your eyes, say your move, and hear your opponent's response. Step-by-step training makes it achievable for everyone.")
    
      whyUniqueHeading.value =translatePhrase("Why Verbal Chess is Unique")
      whyUniqueSubheading.value =translatePhrase("Voice control allows you to focus on your game without being distracted by touching the screen. Perfect for multitaskers, users with disabilities, and anyone looking for a more immersive chess experience.")
      
      experienceHeading.value =translatePhrase("Experience Verbal Chess Anywhere, Anytime")
      experienceSubheading.value =translatePhrase("We are dedicated to broadening and developing chess as art, recreation, and as a significant element of culture.")

      readyToPlay.value =translatePhrase("Ready to Play?")
      contactString.value =translatePhrase("Contact us")
   }

    onMounted(() => {
      console.log("in mounted new landing page")
      if (!props.fromMainPage)
        connectionStore.setRunRequestFromLandingPage("no")
    })

    function reloadWithParam(paramName, paramValue) {
        var currentUrl = window.location.href;
        var newUrl;

        // Check if the URL already has a query string
        if (currentUrl.indexOf('?') > -1) {
            // If the parameter already exists, update its value
            if (currentUrl.indexOf(paramName + '=') > -1) {
                newUrl = currentUrl.replace(new RegExp(paramName + '=[^&]*'), paramName + '=' + paramValue);
            } else {
                // If not, append the new parameter
                newUrl = currentUrl + '&' + paramName + '=' + paramValue;
            }
        } else {
            // If no query string, add the first parameter
            newUrl = currentUrl + '?' + paramName + '=' + paramValue;
        }
        console.log("NEW URL",newUrl)
        window.location.href = newUrl;

    }

  function handleChange(ev,which) {
    console.log('ionChange fired with value: ' + ev.detail.value,which);

    switch (which) {
      case "language" :
        // if language changed, reload page
        if (languageInUse.value == ev.detail.value)
          break
        connectionStore.setLanguageIncludingSystem(ev.detail.value)
        languageInUse.value = ev.detail.value
        setTranslationLanguage(languageInUse.value)
        translateText()
        //window.location.reload(); // Or simply location.reload();
        break
  
    }
   
  }

  function handleCancel() {
    //console.log('ionCancel fired');
  }
  function handleDismiss() {
    //console.log('ionDismiss fired');
  }

  function onClick(result) {
    console.log("CLICK",result)
    switch (result) {
      case "android" :
        window.location.href = "https://play.google.com/store/apps/details?id=com.conceptual.verbalchess"
        break
      case "ios" :
        window.location.href = "https://apps.apple.com/us/app/verbal-chess/id1602860192"
        break
      case "web" :
        if (!props.fromMainPage)
          connectionStore.setRunRequestFromLandingPage("yes")
        location.reload()
        break
      case "chessvis" :
        window.location.href = "https://www.chessvis.com/"
        break
      case "features" :
      case "videos" :
      case "home" :
        document.getElementById(result).scrollIntoView({ behavior: 'smooth' });
        break
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "done" || currentWord == "mute" || currentWord == "listen")
          return [currentWord,""]

        if (currentWord == "scroll") {
            if (nextWord == "up") {
                return ["scroll", "up"]
            }
            if (nextWord == "down") {
                return ["scroll", "down"]
            }
        }
        
        // add choices here
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }
function processWords(text) {
    //console.log("text in engine Menu ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "scroll" :
        scrollElement("scroll_point",returnArray[1])
        break
      case "done" :
        emit("where-next","/")    
        break
    }
  }

  function toolbarClick(arrayIndex) {
    switch (arrayIndex) {
      case TOOLBAR_UP :
        processWords("command scroll up")
        break
      case TOOLBAR_DOWN :
        processWords("command scroll down")
        break
    }
  }

   function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }  

</script>

<style scoped>

  /* @import 'bootstrap-icons/font/bootstrap-icons.css'; */
  /*@import 'bootstrap/dist/css/bootstrap.min.css';*/

.install-hint {
  display: block;
  text-align: center;
  font-style: italic;
  font-size: 13px;
  color: black;
  margin-top: 0px;
}

.install-hint-white {
  color : white;
}

.tall-button {
  height: 41px;
  --padding-top: 8px;
  --padding-bottom: 8px;
}

.hero {
  color : black;
  text-align: center;
  background-color: #E7D4B4;
  margin: 0px;
}

.section2 {
  background-color: #FFFDFA;
  color : black;
  margin : 0px;
}

.dark_tan_background {
  background-color: #AE8968;
  color : white;
  margin : 0px;
}

.white_background {
  background-color: #FCFAF7;
  color : black;
  margin : 0px;
}

.black_background {
  background-color: black;
  color : white;
  margin : 0px;
}

.very_light_background {
  background-color: #F8F6F4;
  color : black;
  margin : 0px;
}

.stacked_item_heading_spacing {
  margin-bottom : 5px;
}
.stacked_item_spacing {
  margin-top : 15px;
  border-radius: 5px;
}

.margin_between_video_rows {
  margin-top : 20px;
}
.video_frame {
  height : 350px;
  width : 234px;
}
.text_under_video {
  width : 250px;
}
.wide_margin {
  margin-left : 10%;
  margin-right : 10%;
}
.litte_left_right_margin {
  margin-left : 5px;
  margin-right : 5px;
}

.wider_margin {
  margin-left : 20%;
  margin-right : 20%;
}
.big_font_extra_margin_top {
  margin-top : 100px;
}
.ready_to_play_extra_margin {
  margin-top : 30px;
  margin-bottom : 10px;
}

.section_padding_top {
  padding-top : 30px;
}

.big_font {
  font-size : 30px;
  font-weight: bold;
  /* font-family: Georgia, 'Times New Roman', Times, serif; */
  /* font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
  font-family: Times New Roman;
}

.big_font_small_screen {
  font-size : 22px;
  font-weight: bold;
  /* font-family: Georgia, 'Times New Roman', Times, serif; */
  /* font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
  font-family: Times New Roman;
}

.medium_font {
  font-size : 20px;
  font-weight: bold;
  /* font-family: Georgia, 'Times New Roman', Times, serif; */
  /* font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; */
  font-family: Times New Roman;
}

.text_centered {
  text-align: center;
}

.not_wide_margins {
  margin-left : 10px;
  margin-right : 10px;
}

.litte_extra_top_bottom {
  padding-top : 10px;
  padding-bottom : 10px;
}
.small_font {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size : 14px;
    line-height: 1.4rem;
}

.smaller_font {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size : 12px;
    line-height: 1.1rem;
}

.list_smaller_screen {
  margin-left : -30px;
}
.small_font_extra_margin {
  margin-top : 12px;
  margin-bottom : 13px;
}
.hero_buttons {
  color : white;
  font-size: 8px;
  background-color: #AE8968;
}

.padding_extra_bottom {
  padding-bottom : 20px;
}
.xc {
  display: flex;
  align-items: center;
  justify-content: center;
}

.small_gif {
  width : 200px;
  height : 200px;
  border-radius: 10px;
}

.border_rounded {
  border-radius: 10px;
}

 ion-button {
    --background: #AE8968;
  }
</style>